import {webInfo} from "@/api/ui/webInfo";
import {get, keys, set} from "@/utils/storage";
import {isBlank, isNullObj} from "@/utils/fun";

const state = {
    // 屏幕宽度
    resize: 0,
    // 页眉显示
    footerShow: true,
    // 右侧按钮显示
    rightBtn: true,
    // 首页数据
    webInfo: null,
    // 第三方/外来API
    exoticAPI: {
        poetry: 'https://v1.jinrishici.com/all.json'
    }
}
const mutations = {
    // 设置屏幕宽度
    SET_RESIZE(state, resize) {
        state.resize = resize
    },
    // 设置页眉显示
    SET_FOOTER_SHOW(state, footerShow) {
        state.footerShow = footerShow
    },
    // 右侧按钮显示
    SET_RIGHT_BTN(state, rightBtn) {
        state.rightBtn = rightBtn
    },
    // web数据
    SET_WEB_INFO(state, webInfo) {
        state.webInfo = webInfo
        set(keys.webInfo, webInfo, 60 * 60 * 2)
    },
    // 第三方/外来API
    SET_EXOTIC_API(state, exoticAPI) {
        if (!isNullObj(state.exoticAPI)) {
            exoticAPI = state.exoticAPI
        }
        state.exoticAPI = exoticAPI
        set(keys.exoticAPI, exoticAPI, 60 * 60 * 2)
    }
}
const actions = {
    // 获取web数据
    async GET_WEB_INFO({commit}) {
        await webInfo()
            .then(res => {
                delete res.webId
                commit('SET_WEB_INFO', res)
            }).catch(_ => {
            })
    },
    // 初始化数据
    async INIT_WEB({commit}) {
        commit('SET_WEB_INFO', get(keys.webInfo))
        commit('SET_EXOTIC_API', get(keys.exoticAPI))
    }
}
const getters = {
    // 屏幕宽度
    resize: state => state.resize,
    // 页眉显示
    footerShow: state => state.footerShow,
    // 右侧按钮显示
    rightBtn: state => state.rightBtn,
    // web数据
    webInfo: state => state.webInfo,
    // 第三方/外来API
    exoticAPI: state => state.exoticAPI
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
